import { render, staticRenderFns } from "./aff-input.vue?vue&type=template&id=4c4d378e"
import script from "./aff-input.vue?vue&type=script&lang=js"
export * from "./aff-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4d378e')) {
      api.createRecord('4c4d378e', component.options)
    } else {
      api.reload('4c4d378e', component.options)
    }
    module.hot.accept("./aff-input.vue?vue&type=template&id=4c4d378e", function () {
      api.rerender('4c4d378e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user-aff/aff-input.vue"
export default component.exports